import { render, staticRenderFns } from "./PgaValutazioneOffertaAggiuntiviPresaleDetails.vue?vue&type=template&id=29223a5d&"
import script from "./PgaValutazioneOffertaAggiuntiviPresaleDetails.vue?vue&type=script&lang=ts&"
export * from "./PgaValutazioneOffertaAggiuntiviPresaleDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardTitle,VDataTable,VSpacer,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29223a5d')) {
      api.createRecord('29223a5d', component.options)
    } else {
      api.reload('29223a5d', component.options)
    }
    module.hot.accept("./PgaValutazioneOffertaAggiuntiviPresaleDetails.vue?vue&type=template&id=29223a5d&", function () {
      api.rerender('29223a5d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Offerte/ValutazioneOfferta/Components/PgaValutazioneOffertaAggiuntiviPresaleDetails.vue"
export default component.exports